export const SET_FILE_ID = 'importRequest/SET_FILE_ID';
export const setFile = id => ({
  type: SET_FILE_ID,
  id
});

export const UPDATE_IMPORT_STATUS = 'importRequest/UPDATE_IMPORT_STATUS';
export const updateImportStatus = status => ({
  type: UPDATE_IMPORT_STATUS,
  status
});
